import React from 'react';

const Sobre = () => (
  <div>
    <h2>SOBRE LA OTRA ISLA</h2>
    <p>
      <em>La otra isla</em> es un proyecto multiplataforma que a través de un
      mediometraje, un archivo documental digital y una exposición, cuenta
      historias de las artes visuales contemporáneas en Cuba. El proyecto
      explora, desde lo testimonial, la micropolítica del quehacer artístico.
      Pone en evidencia las estrategias creativas de los artistas en las
      coordenadas económicas y sociopolíticas impuestas a partir del llamado
      Período Especial, a finales de los años ochenta. Desde entonces, la vida
      de los cubanos comenzó a debatirse entre los designios del control
      estatal, la autogestión, el libre mercado y la migración a otros países.
      En esas circunstancias, hacer, producir y exponer arte en Cuba, así como
      acceder al mercado y a los circuitos internacionales del arte ha implicado
      sostener una agenda que sortea las dificultades económicas y las
      limitaciones ideológicas para seguir gestando un arte crítico en la isla,
      a la par de posicionar a artistas y propuestas creativas en un marco de
      visibilidad internacional.
    </p>
  </div>
);
export default Sobre;
